// router/index.ts
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/home.vue";
import About from "../views/about.vue";
import Signin from "../views/signin.vue";
import Reset from "../views/reset.vue";
import Signup from "../views/signup.vue";
import Youtube from "../views/youtubetranscriptor.vue";
import VideoEditor from "../views/videotranscriptor.vue";
import AudioTranscriptor from "../views/audiotranscriptor.vue";
import Checkout from "../views/checkout.vue";
import Notifications from "../views/notifications.vue";
import Success from "../views/success.vue";
import Settings from "../views/settings.vue";
import PrivacyPolicy from "../views/privacypolicy.vue";
import Support from "../views/support.vue";
import NotFound from "../views/notFound.vue";
import VerifyEmail from "../views/verifyemail.vue";
import { useAuthStore } from "../store/auth";
import Pricing from "../views/pricing.vue";
import Orders from "../views/orders.vue";
import Terms from "../views/terms.vue";
import FreeYoutube from "../components/free_youtube_component.vue";
import CookiesPolicy from "../views/cookiespolicy.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/industries",
    name: "Industries",
    component: About,
  },
  /* {
    path: "/checkout",
    name: "checkout",
    component: Checkout,
    meta: {
      requiresAuth: true,
    },
  }, */
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/cookies-policy",
    name: "CookiesPolicy",
    component: CookiesPolicy,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: Pricing,
  },
  {
    path: "/youtube-transcription",
    name: "Youtube",
    component: Youtube,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/video-transcription",
    name: "VideoEditor",
    component: VideoEditor,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/audio-transcription",
    name: "AudioTranscriptor",
    component: AudioTranscriptor,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/orders",
    name: "Orders",
    component: Orders,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/support",
    name: "Support",
    component: Support,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/signing",
    name: "Signin",
    component: Signin,
    beforeEnter: (to, from, next) => {
      if (useAuthStore().token) {
        next({ name: "Home" });
      } else {
        next();
      }
    },
  },
  {
    path: "/success",
    name: "Success",
    component: Success,
    meta: { title: "Thank you", requiresAuth: true },
  },
  {
    path: "/signing-up",
    name: "Signup",
    component: Signup,
    beforeEnter: (to, from, next) => {
      if (useAuthStore().token) {
        next({ name: "Home" });
      } else {
        next();
      }
    },
  },
  {
    path: "/reset",
    name: "Reset",
    component: Reset,
    beforeEnter: (to, from, next) => {
      if (useAuthStore().token) {
        next({ name: "Home" });
      } else {
        next();
      }
    },
  },
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: VerifyEmail,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/free-youtube-transcription",
    name: "FreeYoutube",
    component: FreeYoutube,
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
